// extracted by mini-css-extract-plugin
module.exports = {"buttonDetail":"button_buttonDetail__WAijw","menuButton":"button_menuButton__MAjSp","burgerButton":"button_burgerButton__x_NFj"};